var map = {
	"./jamilya_step_10.svg": [
		5939,
		939
	],
	"./jamilya_step_11.svg": [
		698,
		698
	],
	"./jamilya_step_2.svg": [
		8500,
		500
	],
	"./jamilya_step_3.svg": [
		5765,
		765
	],
	"./jamilya_step_4.svg": [
		7336,
		336
	],
	"./jamilya_step_5.svg": [
		5241,
		241
	],
	"./jamilya_step_6.svg": [
		7842,
		842
	],
	"./jamilya_step_7.svg": [
		9330,
		330
	],
	"./jamilya_step_8.svg": [
		1735,
		735
	],
	"./jamilya_step_9.svg": [
		9858,
		858
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1569;
module.exports = webpackAsyncContext;